/**
 * The inquiry form's choices and its spam trap's name: what the public form
 * draws, and what `inquiry.ts` checks a submitted answer against.
 *
 * NO ZOD HERE. The form imports this to draw itself, and every public page is
 * one bundle; the validator loads only when a visitor presses Send (TASK-108,
 * Lighthouse on a phone). Keep this file to plain values.
 *
 * These are content: edit the wording freely. Stored rows keep the label that
 * was chosen, so changing an option never invalidates an old inquiry
 * (DATA_MODEL §3).
 */
export const INDUSTRIES = [
    'Construction / contracting',
    'Field service / trades',
    'Wholesale / distribution',
    'Manufacturing',
    'Professional services',
    'Logistics / transportation',
    'Property management',
    'Retail / e-commerce',
    'Healthcare / clinics',
    'Other',
];
export const COMPANY_SIZES = [
    'Just me',
    '2–10 people',
    '11–50 people',
    '51–200 people',
    'More than 200',
];
export const TIMELINES = [
    'As soon as possible',
    'In the next 1–3 months',
    'In 3–6 months',
    'Just exploring',
];
/**
 * The honeypot's field name. A visually hidden, `tabindex=-1`, unlabelled-for-
 * humans input a person never fills and a form-filling bot usually does.
 * Named like something a bot wants to complete.
 */
export const HONEYPOT_FIELD = 'website';
//# sourceMappingURL=inquiry-options.js.map